.listWrapper {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	justify-content: center;
	width: 100%;
}

.categoryTitle:global(.MuiTypography-root) {
	padding-left: 10px;
	font-weight: 700;
	font-size: 0.9375rem;
}

.accordion {
	border-radius: 7px;
	box-shadow: 0 0 5px 0 rgb(0 0 0/20%);
}

.accordionSummary {
	display: flex;
	flex-direction: column;
}

.accordianBody {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	padding-top: 0.625rem;
}
